// Generated by scripts/build-ui-icons.mjs.
export { CheckCircle as default } from "../ui/glyphs-2";
